import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class MwAboutFeaturesMember extends Component {
  @service storyblok;

  get getMemberDesc() {
    return this.storyblok.richTextResolver.render(this.args.blok.memberDesc);
  }
}
